export class BaseList<T> {
  count: number;
  data: T[];

  constructor(v: Partial<BaseList<T>> = {}) {
    Object.assign(this, v);
    this.data = v.data ? v.data.map(d => d as T) : [];
  }
}
